import React from 'react';
import ReactDOM from 'react-dom/client';
import './aws-config';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Navbar1 from './components/navbar1';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Navbar1/>
    <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
